import './CompanyCustomer.scss'

import { Icon } from '@tallink/components-lib'
import React from 'react'
import { useSelector } from 'react-redux'

import { isCompanyCustomerLogged } from '../../../../selectors/selectors'
import DesktopCompanyCustomerLoginForm from './CompanyCustomerLoginForm/DesktopCompanyCustomerLoginForm'
import LoggedCompanyCustomer from './LoggedCompanyCustomer/LoggedCompanyCustomer'

export default function CompanyCustomer() {
  const companyCustomerLogged = useSelector(isCompanyCustomerLogged)

  return (
    <section className="company-customer">
      <Icon className="company-customer-icon" size="xxxl" type="customer-in-circle" />
      {companyCustomerLogged ? <LoggedCompanyCustomer /> : <DesktopCompanyCustomerLoginForm />}
    </section>
  )
}
